import { useNavigate, useParams } from "react-router-dom";
import CreateJobTitle from "./CreateJobTitle";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import sucessBee from "../../../../assets/images/SuccessBee.svg";
import { popupInitialData } from "utils";
import { useEffect, useState } from "react";
import { getCatalogUpdateVehicleLevel, setCatalogUpdateVehicleLevel } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction";
import userProfileSelectors from "../../../../../redux/UserProfile/selectors"
import { getEditJobTitleData, getSaveJobTitle, setEditJobTitleData, setIsJobTitleSaved } from "Store/AssetManagement/JobTitle/JobTitleAction";
import permissions, { isAuthorized } from "client/utils/Permissions";

const CreateJobTitleContainer = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [popupContent, setPopupContent] = useState<any>(popupInitialData);
  const [assignmentGroupList, setAssignmentGroupList] = useState<any>([]);
  const [jobTitle, setJobTitle] = useState<any>();
  const [assignmentGroup, setAssignmentGroup] = useState<any>();
  const [isActive, setIsActive] = useState<any>(true);
  const [isLogoed, setIsLogoed] = useState<any>();
  const initialError = { jobTitleError: '', assignmentGroupError: '' };
  const [error, setError] = useState<any>(initialError);
  const [isChangesOccured, setIsChangesOccured] = useState<boolean>(false);

  let { id } = useParams();

  const {
    catalogUpdateVehicleLevel,
    userData,
    isJobTitleSaved,
    editJobTitleDataById
  }: any = useSelector(
    (state: any) => ({
      catalogUpdateVehicleLevel: state.CatalogDropDownUpdateReducers.catalogUpdateVehicleLevel,
      userData: userProfileSelectors.getUserDetails(state),
      isJobTitleSaved: state.JobTitleReducer.isJobTitleSaved,
      editJobTitleDataById: state.JobTitleReducer.editJobTitleDataById
    })
  )

  const clearvalues = () => {
    setJobTitle('');
    setAssignmentGroup('');
    setIsActive(true);
    setIsLogoed(false);
    setError(initialError)
    setIsChangesOccured(false)
  }

  useEffect(() => {
    if (userData?.permissions?.length > 0) {
      if(!isAuthorized(permissions.View_JobTitle) ){
        navigate('/ordermanagement');
      } 
    }
  }, [userData?.permissions])

  const hideDialog = () => {
    setPopupContent({ ...popupContent, isDialogVisible: false })
  };

  useEffect(() => {
    dispatch(getCatalogUpdateVehicleLevel());
    setIsActive(true)
    return () => {
    dispatch(setCatalogUpdateVehicleLevel([]));
    dispatch(setIsJobTitleSaved(null));
    dispatch(setEditJobTitleData(null));
    }
  }, [])

  useEffect(() => {
    if (id) {
      dispatch(getEditJobTitleData(id));
    }
  }, [id])

  useEffect(() => {
    if (editJobTitleDataById?.hasOwnProperty('jobTitle')) {
      const selectedAssignmentGroup = assignmentGroupList.find((item: any) => item.key == editJobTitleDataById?.assignmentGroupId);
      setAssignmentGroup(selectedAssignmentGroup);
      setJobTitle(editJobTitleDataById?.jobTitle);
      setIsActive(editJobTitleDataById?.isActive);
      setIsLogoed(editJobTitleDataById?.logoed);
    }
  }, [editJobTitleDataById])

  useEffect(() => {
    if (catalogUpdateVehicleLevel?.length) {
      const dropdownList: any = catalogUpdateVehicleLevel?.map((item: any) => {
        return { label: item.text, key: item.value, ...item }
      })
      setAssignmentGroupList(dropdownList);
      if (id) {
        const selectedAssignmentGroup = dropdownList.find((item: any) => item.key == editJobTitleDataById?.assignmentGroupId);
        setAssignmentGroup(selectedAssignmentGroup);
      }
    }

  }, [catalogUpdateVehicleLevel])

  useEffect(() => {
    if (isJobTitleSaved !== null) {
      if (isJobTitleSaved?.isValid) {
        const descriptionTxt = (<p>Job Title is saved successfully.</p>);
        setPopupContent({
          ...popupContent,
          titleImg: sucessBee,
          title: "SUCCESS",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: descriptionTxt,
          outlineBtnText: "Close",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: () => {
            hideDialog();
            clearvalues();
            navigate('/ordermanagement/catalogmanagement');
          }
        })
      }else if(isJobTitleSaved?.isExistInOtherVehicle && isJobTitleSaved?.isExistInOtherVehicle != null){
        const descriptionTxt = (<p>{isJobTitleSaved?.validationMessage}</p>);
        setPopupContent({
          ...popupContent,
          titleImg: ConfirmationBee,
          title: "CONFIRMATION",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: descriptionTxt,
          outlineBtnText: "No",
          primaryBtnText: "Yes",
          isSingleConfirmationBtn: false,
          popupPrimarybtnOnclick: () => {
            hideDialog();
            onClickAdd(true);
          },
          popupOutlinebtnOnclick: () => {
            hideDialog();
          }
        })
      } else if(!isJobTitleSaved?.isValid) {
        const descriptionTxt = (<p>{isJobTitleSaved?.validationMessage}</p>);
        setPopupContent({
          ...popupContent,
          titleImg: ConfirmationBee,
          title: "WARNING",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: descriptionTxt,
          outlineBtnText: "Close",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: () => {
            hideDialog();
          }
        })
      }
    }
  }, [isJobTitleSaved])

  const handleClickBack = () => {
    if (isChangesOccured) {
      setPopupContent({
        ...popupContent,
        titleImg: ConfirmationBee,
        title: "CONFIRMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: 'If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?',
        primaryBtnText: "Yes",
        outlineBtnText: "No",
        popupOutlinebtnOnclick: () => {
          hideDialog()
        },
        popupPrimarybtnOnclick: () => {
          hideDialog();
          onClickCancel();
        },
        isSingleConfirmationBtn: false,
      })
    } else {
      onClickCancel();
    }
  }

  const onClickCancel = () => {
    clearvalues();
    navigate('/ordermanagement/catalogmanagement');
  }

  const breadcrumlist = [
    { text: 'Catalog Management', key: 'f1', onClick: () => handleClickBack() },
    { text: id ? "Edit Job Title" : "Add New Job Title", key: "f2" },
    {}
  ]

  const onClickAdd = (isValidSaveExistingValue?: any) => {
    let isValid = validate('Save', { jobTitle: jobTitle, assignmentGroup: assignmentGroup });
    if (isValid) {
      const payload = {
        jobTitleId: id ?? 0,
        jobTitle: jobTitle,
        vehicleLevelId: assignmentGroup?.key,
        isActive: isActive ?? false,
        logoed: isLogoed ?? false,
        savedBy: userData?.emailId,
        isValidSaveExistingValue: isValidSaveExistingValue
      }
      dispatch(getSaveJobTitle(payload));
    }
  }
  const onIsActiveChange = (e: any, item: any) => {
    e.preventDefault();
    setIsChangesOccured(true)
    setIsActive(item);
  }

  const onLogoedChange = (e: any, item: any) => {
    e.preventDefault();
    setIsChangesOccured(true)
    setIsLogoed(item);
  }

  const validate = (name?: any, value?: any) => {
    let isError = true;
    const errors = error;
    if (name == "JobTitle" || name == 'Save') {
      if (value?.jobTitle?.trim().length === 0 || !value?.jobTitle) {
        isError = false;
        errors.jobTitleError = 'Please enter Job Title';
      } else if (value?.jobTitle?.trim().length > 50) {
        isError = false;
        errors.jobTitleError = 'Please enter Job Title less than 50 characters';
      } else {
        errors.jobTitleError = '';
      }
    }
    if (name == "AssignmentGroup" || name == 'Save') {
      if (!value?.assignmentGroup) {
        isError = false;
        errors.assignmentGroupError = 'Please select Assignment Group';
      } else {
        errors.assignmentGroupError = '';
      }
    }
    setError({ ...errors });
    return isError;
  }

  const onChangeAssignmentGroup = (item: any) => {
    setIsChangesOccured(true)
    validate("AssignmentGroup", { jobTitle: jobTitle, assignmentGroup: item });
    setAssignmentGroup(item);
  }
 
  const onChangesJobTitle = (e: any) => {
    e.preventDefault();
    setIsChangesOccured(true)
    validate("JobTitle", { jobTitle: e.target.value, assignmentGroup: assignmentGroup });
    setJobTitle(e.target.value);
  }
  return (
    <CreateJobTitle
      breadcrumlist={breadcrumlist}
      handleClickBack={handleClickBack}
      popupContent={popupContent}
      hideDialog={hideDialog}
      assignmentGroupList={assignmentGroupList}
      onClickAdd={onClickAdd}
      isActive={isActive}
      isLogoed={isLogoed}
      onIsActiveChange={onIsActiveChange}
      onLogoedChange={onLogoedChange}
      jobTitle={jobTitle}
      assignmentGroup={assignmentGroup}
      onChangesJobTitle={onChangesJobTitle}
      onChangeAssignmentGroup={onChangeAssignmentGroup}
      error={error}
      id = {id}
    />
  )
}

export default CreateJobTitleContainer;
